import styled from '@emotion/styled';

export const StyledNav = styled.div`
    .MuiTabs-scroller {
        margin: 0 auto;
        max-width: 1184px;
    }

    .nav-tabs-tab {
        font-weight: 400;
        font-size: ${(props) => props.theme.fontSize.copyTextS};
        transition: opacity 0.3s;

        &:hover,
        &:focus {
            color: ${(props) => props.theme.shades.white};
            text-decoration: unset;
        }
        &:hover {
            opacity: 1;
        }

        span {
            transition: transform 0.3s;
        }
    }

    .nav-tabs-indicator {
        background-color: ${(props) => props.theme.shades.white};
        bottom: 1px;
        height: 3px;
    }

    .nav-bar-active {
        span {
            transform: scale(1.1);
        }
        &:hover {
            opacity: 1;
        }
    }
`;
